import { createContext, useContext, useEffect, useState } from 'react'
import { onAuthStateChanged } from "firebase/auth";
import { auth } from '../Firebase';
import axios from 'axios'

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider( {children} ) {

    const [currentUser, setCurrentUser] = useState(null)
    const [admin, setAdmin] = useState("")
    const [isLoading, setIsLoading] = useState(true)


    const setupAxiosInterceptor = (user) => {
        axios.interceptors.response.use(
            response => response,
            async error => {
                // if the error is a 498 (unauthorized due expired token) and the error config allows retrying
                if (error.response && error.response.status === 498 && !error.config._retry) {
                    // Mark the request for retry
                    error.config._retry = true;

                    try {
                        const tokenResult = await user.getIdTokenResult(true);

                        // if token refresh is successful, update the request headers with the new token
                        error.config.headers.authToken = tokenResult.token
                        axios.defaults.headers.common['AuthToken'] = tokenResult.token;

                        // retry the failed request with the updated token
                        return axios(error.config);

                    } catch (refreshError) {
                        // handle token refresh error, possibly redirect to login or display error message
                        console.error('Failed to refresh token:', refreshError);
                    }
                }

                // If the error is not a 498 or token refresh fails, return the error
                return Promise.reject(error);
            }
        );
    };

    useEffect(() => {
        let unsubscribe= onAuthStateChanged(auth, (user) => {
            if (user) {
                axios.defaults.headers.common['AuthToken'] = user.accessToken;
                setupAxiosInterceptor(user);

                auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    setAdmin(idTokenResult.claims.admin)
                    setCurrentUser(user)
                    setIsLoading(false)

                })
                .catch((error) => {
                    console.log(error);
                });
            } else {
                setCurrentUser(null)
                setIsLoading(false)
                setAdmin(false)
            }
          });

          return unsubscribe;
    }, []);

    const value = {
        currentUser, admin
    }

    return (
        <AuthContext.Provider value={value}>
            {!isLoading && children}
        </AuthContext.Provider>
    )
}
